var map = {
	"./for-each.json": 93922,
	"./if-else.json": 18314,
	"./if.json": 31733,
	"./repeat.json": 31756,
	"models/block/blocks/control/blueprints/for-each.json": 93922,
	"models/block/blocks/control/blueprints/if-else.json": 18314,
	"models/block/blocks/control/blueprints/if.json": 31733,
	"models/block/blocks/control/blueprints/repeat.json": 31756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35941;